// extracted by mini-css-extract-plugin
module.exports = {"email":"SearchBar_email__2ucBr"};